import React from "react"
import PropTypes from "prop-types"

import { ThemeProvider } from "styled-components"
import { defaultTheme } from "shared/Themes"

import { ParallaxProvider } from "react-scroll-parallax"

import { GlobalWrapper } from "shared/Styles/Wrappers"

import { Menu } from "components/Menu"
import {Transition} from "components/Transition"

import SwiperCore, {
  EffectFade,
  Navigation,
  Autoplay,
  Pagination,
} from "swiper"

import "shared/Styles/bebas.css"
import "shared/Styles/sharpgrotesk.css"
import "shared/Styles/global.css"
import "shared/Styles/reset.css"

import "swiper/swiper.scss"
import "swiper/components/navigation/navigation.scss"
import "swiper/components/pagination/pagination.scss"
import "swiper/components/effect-fade/effect-fade.scss"
import { useScript } from "shared/Hooks/useScript"

SwiperCore.use([EffectFade, Navigation, Autoplay, Pagination])

const MainLayout = ({ children, pageContext, location }) => {
  const status = useScript('https://partners.goout.net/pl-warsaw/fundacjabeksinskipl.js')
  if (pageContext.layout === "404") {
    return <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>
  } else {
    return (
      <ParallaxProvider>
        <ThemeProvider theme={defaultTheme}>
          <Transition location={location}>
            <Menu />
            <GlobalWrapper>{children}</GlobalWrapper>
          </Transition>
        </ThemeProvider>
      </ParallaxProvider>
    )
  }
}

MainLayout.propTypes = {
  children: PropTypes.node,
}

export default MainLayout
